import type { SpeedUnit } from '~/utils'

export const useSpeedUnit = () => {
  const { data } = useAuth()

  const speedUnit = computed<SpeedUnit>(
    () => (data.value?.user?.preferred_speed_unit as SpeedUnit) ?? 'kn'
  )

  const unitLabel = computed(() => speedUnitLabel(speedUnit.value))

  const format = (ms: number | null | undefined) => formatSpeed(ms, speedUnit.value)

  const convert = (ms: number) => convertSpeed(ms, speedUnit.value)

  return { speedUnit, unitLabel, formatSpeed: format, convertSpeed: convert }
}
